module.exports = __webpack_public_path__ + "static/media/phone-dark-ic.277ea08c.svg";